import { AT_CARDS_REQUESTS_STATE_SET, ICardsRequestsStateSetAction } from './types';
import { ICardsRequestsState } from '../reducers/types';

export const cardsRequestsStateSetAction = (
    cards: ICardsRequestsState
): ICardsRequestsStateSetAction => ({
    type: AT_CARDS_REQUESTS_STATE_SET,
    cards
});
